<template>
  <div class="fixed top-12 3xl:top-7 left-1/2 -ml-[38rem] w-72 max-xl:hidden">
    <div class="rounded border bg-white px-3 py-8 flex items-center flex-col">
      <TeamLogo
        class="block aspect-square w-32"
        :name="team?.name"
        :slug="team?.slug"
        :logo="team?.logo"
        size="512"
        :alt="team?.abbr"
      />
      <div class="text-center space-y-2">
        <div class="font-heading font-bold text-3xl leading-none">{{ team.name }}</div>
        <div class="text-sm text-slate-500">{{ team.season.name }} {{ team.season.year }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
const team = useTeamStore()
</script>
